import type { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import {
  IntlProvider as _IntlProvider,
  type MessageFormatElement,
} from 'react-intl'

export function IntlProvider({ children }: PropsWithChildren) {
  const { i18n, t } = useTranslation()

  const messages = t('meridian', {
    returnObjects: true,
  }) as unknown as MessageFormatElement[] | string

  return (
    <_IntlProvider
      locale={i18n.language}
      messages={{
        c4r: messages as MessageFormatElement[],
      }}
    >
      {children}
    </_IntlProvider>
  )
}
